export default __webpack_public_path__ + "static/media/quick1s.27dec0ea.svg";